import styled from "styled-components";

const CombinedItemInnerWrapper = styled.div<{ $expanded: boolean }>`
  border-bottom: 0.2px solid #8992a345;
  width: 100%;
  height: ${(props) => (props.$expanded ? "80px" : "0")};
  opacity: ${(props) => (props.$expanded ? 1 : 0)};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: height 300ms ease, opacity 300ms ease;
`;

const NumTargetsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const GeneralConfigurationStyles = {
  CombinedItemInnerWrapper,
  NumTargetsRow,
};

export default GeneralConfigurationStyles;
